import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import React, { useMemo, useState } from "react";
import { Button, ButtonGroup, Modal } from "react-bootstrap";
import { X } from "react-feather";

export const DateRangeFilter = ({
  manualFilters,
  column: {
    filterValue = [],
    preFilteredRows,
    setFilter,
    id,
    Header,
    toggleSortBy,
  },
}) => {
  const [min, max] = useMemo(() => {
    let min, max;
    if (manualFilters) {
      max = new Date();
      min = new Date(0);
    } else {
      min = preFilteredRows.length
        ? new Date(preFilteredRows[0].values[id])
        : new Date(0);
      max = preFilteredRows.length
        ? new Date(preFilteredRows[0].values[id])
        : new Date(0);

      preFilteredRows.forEach((row) => {
        const rowDate = new Date(row.values[id]);

        min = rowDate <= min ? rowDate : min;
        max = rowDate >= max ? rowDate : max;
      });
    }

    return [min, max];
  }, [id, preFilteredRows, manualFilters]);

  const [dateRange, setDateRange] = useState([min, max]);
  const [toggle, setToggle] = useState(false);

  const handleChange = (values) => {
    if (values) {
      setDateRange(values);
      setFilter(values);
      toggleSortBy(false);
    } else {
      clear();
    }
  };

  const setAllTime = () => {
    const max = new Date();
    const min = new Date(0);
    setDateRange([min, max]);
    setFilter([min, max]);
    toggleSortBy(false);
  };

  const setPast30Days = () => {
    const max = new Date();
    const min = new Date(max); // Create a copy of `max`
    min.setDate(max.getDate() - 30);
    setDateRange([min, max]);
    setFilter([min, max]);
    toggleSortBy(false);
  };

  const clear = () => {
    setDateRange([min, max]);
    toggleSortBy(true);
    setFilter(undefined);
  };

  // To match the Bootstrap Form.Control style of default column filters
  const buttonStyle = {
    borderStyle: "solid",
    borderWidth: "1px",
    borderColor: "#ced4da",
    borderRadius: "0.1rem",
  };

  return (
    <>
      <ButtonGroup className="w-100 overflow-auto mb-3">
        <Button
          variant="outline-secondary"
          style={buttonStyle}
          onClick={() => setToggle(!toggle)}
        >
          Choose...
        </Button>
        {filterValue.length ? (
          <Button
            style={{ maxWidth: "40px", zIndex: 3 }} // Fixes left border overlap
            variant="outline-danger"
            onClick={clear}
          >
            <X size={16} />
          </Button>
        ) : null}
      </ButtonGroup>
      <Modal size="sm" show={toggle} onHide={() => setToggle(!toggle)}>
        <Modal.Header closeButton>
          <Modal.Title>Filter by {Header}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="d-flex justify-content-center">
          <DateRangePicker
            minDate={min}
            maxDate={max}
            onChange={handleChange}
            value={dateRange}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-primary"
            onClick={() => {
              setAllTime();
              setToggle(!toggle);
            }}
          >
            All Time
          </Button>
          <Button
            variant="outline-primary"
            onClick={() => {
              setPast30Days();
              setToggle(!toggle);
            }}
          >
            Past 30 Days
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export const dateBetweenFilterFn = (rows, id, filterValues) => {
  const sd = filterValues[0] ? new Date(filterValues[0]) : undefined;
  const ed = filterValues[1] ? new Date(filterValues[1]) : undefined;

  if (ed || sd) {
    return rows.filter((r) => {
      const cellDate = new Date(r.values[id]);

      if (ed && sd) {
        return cellDate >= sd && cellDate <= ed;
      } else if (sd) {
        return cellDate >= sd;
      } else if (ed) {
        return cellDate <= ed;
      }
    });
  } else {
    return rows;
  }
};
